import React from "react";
import get from "lodash/get";

import BlurbHeader from "Components/header/blurb";
import LogoHeader from "Components/header/logo";
import TextHeader from "Components/header/text";
import ShortPress from "Components/press/short";
import LongPress from "Components/press/long";
import BlurbModal from "Components/common/base/blurbModal";
import CustomFitModal from "Components/common/base/customFitModal";
import NarrativeModal from "Components/common/base/narrativeModal";
import GridProductModal from "Components/product/grid";
import CarouselProductModal from "Components/product/carousel";
import ImageListModal from "Components/common/imageListModal";
import TwoGridModal from "Components/common/twoGridModal";
import ImageHeroModal from "Components/common/imageHero";
import CaseStudyListModal from "Components/common/base/caseStudyListModal";
import SocialModal from "Components/common/base/socialModal";
import PhotoCarousel from "Components/common/base/photoCarousel";
import ImageBlurbModal from "Components/common/base/imageBlurbModal";
import FaqModal from "Components/common/base/faqModal";
import DividerModal from "Components/common/base/divider";

const ComponentLayout = ({ modals, designID }) => {
  return (
    <>
      {modals.map((modal, i) => {
        switch (modal.__typename) {
          case "STRAPI_ComponentHeaderBlurbHeader":
            return (
              <BlurbHeader
                content={modal.content}
                textColor={get(modal, "textColor.color", undefined)}
                backgroundColor={get(modal, "backgroundColor.color", undefined)}
                backgroundAsset={modal.backgroundAsset}
                vimeoURL={modal.vimeoURL}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentBaseBlurbModal":
            return (
              <BlurbModal
                align={modal.align}
                content={modal.content}
                asset={modal.asset}
                textColor={modal.textColor}
                backgroundColor={modal.backgroundColor}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentPressShortPress":
            return <ShortPress key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentProductCarouselProduct":
            return (
              <CarouselProductModal
                title={modal.title}
                productLists={modal.productLists}
                textColor={modal.textColor}
                backgroundColor={modal.backgroundColor}
                key={`homepageModal-${i}`}
              />
            );

          case "STRAPI_ComponentBaseCustomFitModal":
            return (
              <CustomFitModal
                title={modal.title}
                description={modal.description}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentBaseImageListModal":
            return <ImageListModal key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentProductGridProduct":
            return (
              <GridProductModal
                title={modal.title}
                productLists={modal.productLists}
                textColor={modal.textColor}
                backgroundColor={modal.backgroundColor}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentHeaderLogoHeader":
            return (
              <LogoHeader
                logo={modal.logo}
                subtitle={modal.subtitle}
                ctas={modal.ctas}
                textColor={get(modal, "textColor.color", undefined)}
                backgroundColor={get(modal, "backgroundColor.color", undefined)}
                backgroundAsset={modal.backgroundAsset}
                vimeoURL={modal.vimeoURL}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentHeaderTextHeader":
            return (
              <TextHeader
                subtitle={modal.subtitle}
                title={modal.title}
                ctas={modal.ctas}
                textColor={get(modal, "textColor.color", undefined)}
                backgroundColor={get(modal, "backgroundColor.color", undefined)}
                backgroundAsset={modal.backgroundAsset}
                vimeoURL={modal.vimeoURL}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentPressLongPress":
            return (
              <LongPress
                title={modal.title}
                asset={modal.asset}
                logos={modal.logos}
                backgroundColor={get(modal, "backgroundColor.color", undefined)}
                reviews={modal.reviews}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentBaseNarrativeModal":
            return (
              <NarrativeModal
                title={modal.title}
                imageDescriptions={modal.imageDescriptions}
                ctas={modal.ctas}
                textColor={modal.textColor}
                backgroundColor={modal.backgroundColor}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentBaseImageHeroModal":
            return (
              <ImageHeroModal
                imageDescription={modal.imageDescription}
                key={`homepageModal-${i}`}
              />
            );
          case "STRAPI_ComponentBaseSocialModal":
            return (
              <SocialModal
                designID={designID}
                key={`homepageModal-${i}`}
                {...modal}
              />
            );
          case "STRAPI_ComponentBaseCaseStudyListModal":
            return <CaseStudyListModal key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentBaseTwoGridModal":
            return <TwoGridModal key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentBaseImageBlurbModal":
            return <ImageBlurbModal key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentBasePhotoCarousel":
            return <PhotoCarousel key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentBaseFaqModal":
            return <FaqModal key={`homepageModal-${i}`} {...modal} />;
          case "STRAPI_ComponentBaseDivider":
            return <DividerModal key={`homepageModal-${i}`} {...modal} />;
        }
      })}
    </>
  );
};

export default ComponentLayout;
